<template>
  <el-select class="td_select"
             v-model="values"
             :loading="loading"
             clearable
             :disabled="disabled"
             filterable>
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.name"
      :value="parseInt(item.userId)"
      @click.native="handleSelect(item)">
<!--        <el-avatar size="small" :src="item.avatar === null? item.avatar : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>-->
      <el-avatar size="small" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
        <div style="padding: 2.5px;line-height: 20px;">
          {{item.name}}
          <el-row>
            <el-col :span="12">
              <span>{{item.username}}</span>
            </el-col>
            <el-col :span="12">
              <span>{{item.position}}</span>
            </el-col>
          </el-row>
        </div>
    </el-option>
  </el-select>
</template>
<script>
import { alluser } from '@/api/admin/user'
import { validatenull } from '@/tdcommon/validate'

export default {
  name: 'd2-container-mdmselect',
  data () {
    return {
      values: parseInt(this.value),
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      default: () => 0
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    remoteMethod () {
      this.loading = true
      alluser().then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      if (!validatenull(val)) {
        this.values = parseInt(val)
      }
    }
  },
  mounted () {
    this.remoteMethod()
  }
}
</script>

<style lang="scss" scoped>
  .td_option {
    height: 50px;
    display: flex;
    align-items: center;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-member/index.vue"
}
</vue-filename-injector>
